import React from 'react'
import Time from 'react-timeago'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import englishStrings from 'react-timeago/lib/language-strings/en'
import dutchStrings from 'react-timeago/lib/language-strings/nl'
import frenchStrings from 'react-timeago/lib/language-strings/fr'
import germanStrings from 'react-timeago/lib/language-strings/de'
import hungarianStrings from 'react-timeago/lib/language-strings/hu'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import portugueseStrings from 'react-timeago/lib/language-strings/pt-br'
import { useLanguage } from '../LanguageContext'

const locales = {
  en: englishStrings,
  nl: dutchStrings,
  fr: frenchStrings,
  de: germanStrings,
  hu: hungarianStrings,
  es: spanishStrings,
  pt: portugueseStrings,
}

const TimeAgo = ({ date }) => {
  const language = useLanguage()
  return (
    <Time
      date={date}
      formatter={buildFormatter(locales[language.split('-')[0]])}
    />
  )
}

export default TimeAgo
